import { createBrowserRouter, RouterProvider } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ErrorBoundary } from "../themes/default/components/error/ErrorBoundary";
import { Suspense } from "react";
import ManageAmbassador from "../themes/default/pages/ManageAmbassador/ManageAmbassador.page";
import { RO_MANAGE_AMBASSADOR, RO_WEBINAR } from "../constants/Routes";
import Redirect from "../themes/default/components/Redirect.component";
import Webinar from "../themes/default/pages/Webinar/Webinar.page";
import Form from "../themes/default/pages/Forms/Form.component";
import SuccessPage from "../themes/default/pages/SuccessPage/Success";

const Loading = () => {
  return (
    <div className="flipping-body">
      <div className="flipping"></div>
    </div>
  );
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

export const router = createBrowserRouter([
  {
    path: "/",
    errorElement: <ErrorBoundary />,

    element: (
      <Suspense fallback={<Loading />}>
        <Redirect to="/as" />
      </Suspense>
    ),
  },
  {
    path: `/forms`,
    errorElement: <ErrorBoundary />,
    element: (
      <Suspense fallback={<Loading />}>
        <Form />
      </Suspense>
    ),
  },
  {
    path: `/:moduleType-signup/success`,
    errorElement: <ErrorBoundary />,
    element: (
      <Suspense fallback={<Loading />}>
        <SuccessPage />
      </Suspense>
    ),
  },
  {
    path: `${RO_MANAGE_AMBASSADOR}`,
    errorElement: <ErrorBoundary />,
    element: (
      <Suspense fallback={<Loading />}>
        <ManageAmbassador />
      </Suspense>
    ),
  },
  {
    path: `${RO_WEBINAR}`,
    errorElement: <ErrorBoundary />,
    element: (
      <Suspense fallback={<Loading />}>
        <Webinar />
      </Suspense>
    ),
  },
]);

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
